import Vue from 'vue'
import MixinCommon from '~/mixins/common'
import LocalizeValidation from '~/mixins/localizeValidation'
Vue.mixin(MixinCommon)
Vue.mixin(LocalizeValidation)
